import { Api, Req } from "@quipa/api";

export const getRooms = (clientId?: number, nameSort?: "asc" | "desc", searchStr?: string) =>
    Api.createAction(Api.GET_ROOMS, { clientId, nameSort, searchStr }, { authenticated: true });

export const addRoom = (room: Api.AddRoomAction[Req]) =>
    Api.createAction(Api.ADD_ROOM, room, { authenticated: true });
